import type { FaireProductEntity } from "../../entity_types/product";

export const p_vmvr73nqmh: FaireProductEntity = {
  token: "p_vmvr73nqmh",
  type: "product",
  name: "NEW Sprite Icy Raspberry - TAIWAN (12 COUNT)",
  brandToken: "b_pdahr8yenn",
  brandName: "Exotic Snacks Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/45aa799b98bbb34b4a7b4cd08890497acf40fb28fab6b499fad1f4775abaa361.jpeg",
  galleryImageUrls: [],
  priceDollars: 41.57,
  description:
    "Refresh your senses with Sprite Cool Raspberry from Taiwan! This 12-count pack combines Sprite’s signature lemon-lime fizz with a cool burst of cranberry for a perfectly balanced, fruity twist. A crisp, limited-edition soda that’s both tangy and refreshing — perfect for collectors and soda lovers alike.\n\nSuggested Retail Price: $6.99\n",
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:38.203Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
